import { useGetAllFeaturesQuery } from "App/services/featureServiceApi";

const useFeatureEnabled = (featureKey) => {
  const { data: features, isLoading, isError } = useGetAllFeaturesQuery();

  if (isLoading || isError || !features) return true;

  const feature = features.find((f) => f.feature_key === featureKey);
  return feature ? Boolean(feature.is_enabled) : true;
};

export default useFeatureEnabled;
